import { FrequencyCode, EndType, PaymentLabel } from '../webgiving-generated';
import { Formatter } from '../../Shared/utils/formatter';
import { getNextFirstOrFifteenthAfter } from './date-utils';

export function frequencyLabelSentenceCase(frequency: FrequencyCode) {
	return frequencyLabel[frequency];
}

export function frequencyLabelLowerCase(frequency: FrequencyCode) {
	return frequencyLabel[frequency].toLowerCase();
}

const frequencyLabel: { [key: number]: string } = {
	[FrequencyCode.OneMinute]: 'Every minute',
	[FrequencyCode.FiveMinutes]: 'Every 5 minutes',
	[FrequencyCode.FourHours]: 'Every 4 hours',
	[FrequencyCode.Weekly]: 'Every week',
	[FrequencyCode.Fortnightly]: 'Every 2 weeks',
	[FrequencyCode.FirstAndFifteenth]: '1st & 15th monthly',
	[FrequencyCode.Monthly]: 'Every month',
};

export function endRecurringForDisplay(endType: EndType | null, endDate: Date | null | undefined, endOccurrences: number | null | undefined, paymentLabel: PaymentLabel) {
	if (endType === null) {
		return '';
	}
	if (endType === EndType.Date && endDate) {
		return `Ending on ${Formatter.formatDate(endDate, 'MMM D, YYYY')}`;
	}
	if (endType === EndType.Occurrences && endOccurrences !== null) {
		return `Ending after ${endOccurrences} ${endOccurrences === 1 ? paymentLabel.NounLowerCase : paymentLabel.NounPluralLowerCase}`;
	}
	return '';
}

export function endRecurringForDisplayObject(endType: EndType | null, endDate: Date | null | undefined, endOccurrences: number | null | undefined, paymentLabel: PaymentLabel): {
    text: string;
    params?: { [key:string]:string };
} {
	if (endType === null) {
		return { text: ''};
	}
	if (endType === EndType.Date && endDate) {
		return { text: `Ending on {{date}}`, params: { date: Formatter.formatDate(endDate, "MMM D, YYYY")} };
	}
	if (endType === EndType.Occurrences && endOccurrences !== null) {
		return {
			text: `Ending after {{number}} ${endOccurrences === 1 ? paymentLabel.NounLowerCase : paymentLabel.NounPluralLowerCase}`, params: { number: `${endOccurrences}` },
		};
	}
	return { text: ''};
}

export function dateOfFirstGiftForDisplay(frequency: FrequencyCode, startDate: Date) {
	if (frequency === FrequencyCode.FirstAndFifteenth) {
		const dateOfFirstPayment = getNextFirstOrFifteenthAfter(moment(startDate)).toDate();
		return Formatter.formatDate(dateOfFirstPayment, 'MMM D, YYYY');
	}
	return Formatter.formatDate(startDate, 'MMM D, YYYY');
}
